import { iframeDataBridge } from '@/iframe/iframeDataBridge';
import { authenticatedFetch, getApiUrl } from '@/utils/auth/authService';
import { log } from '@/utils/core/vueLogger.js';
import { CacheManager } from '@/utils/core/cacheManager.js';

const notificationCache = new CacheManager('VueCache', 'cache', {
	maxAge: 5 * 60 * 1000,
	memoryCacheTTL: 5 * 60 * 1000,
	logCategory: 'Notification',
	keyPrefix: () => `${iframeDataBridge.getCustomer() ?? 'unknown'}.${iframeDataBridge.getCurrentUser()?.id ?? 'unknown'}.notifications.`,
});

export async function getNotifications(forceRefresh = false) {
	return notificationCache.fetchOrCache('all', fetchNotificationsFromAPI, { forceRefresh, fallback: [], backgroundRefresh: true });
}

async function fetchNotificationsFromAPI() {
	const response = await authenticatedFetch(getApiUrl('Communication/Notifications'), { method: 'GET' }, 'token');
	if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

	const notifications = await response.json();
	log('success', 'Notification', `✅ Fetched ${notifications.length} notifications`);
	return notifications;
}

export async function refreshNotifications() {
	notificationCache.clearMemory();
	await notificationCache.clear();
}

// notification.js markAsRead(): POST .../ChangeState, state 1 = Read (0 = New, 2 = Old). The token
// header is picked by application (SALFO -> tokenSales, DCRFO -> tokenDoc), like the legacy itself.
export async function markNotificationRead(id, application) {
	const tokenType = application === 'DCRFO' ? 'tokenDoc' : 'tokenSales';
	const response = await authenticatedFetch(getApiUrl(`Communication/Notifications/${id}/ChangeState`), { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: 'state=1' }, tokenType);
	if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
}
